import { createSlice } from "@reduxjs/toolkit";
import { updateProfileAPI } from "../../api/profile";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const updateProfileSlice = createSlice({
  name: "updateProfile",
  initialState: data,
  reducers: {
   updateProfileSlice(state) {
      state.isLoading = true;
    },
   updateProfileSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    updateProfileSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    updateProfileSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const updateProfileHandler = (data:any) => async (dispatch: any) => {
  try {
    dispatch(updateProfileAction.updateProfileSlice());
    const response: any = await updateProfileAPI(data);
    
    dispatch(updateProfileAction.updateProfileSliceSuccess(response));
  } catch (e: any) {
    dispatch(updateProfileAction.updateProfileSliceFailure(e?.response?.data));
  }
};
export default updateProfileSlice.reducer;
export const updateProfileAction = updateProfileSlice.actions;
